(() => {
  'use strict';
  if (window.BuildHomeWishlist) { window.BuildHomeWishlist.sync(); return; }
  const storageKey = 'build-home-wishlist-v1';
  const departmentNames = { ppr: 'PIPES & FITTINGS', faucet: 'FAUCETS & BATH', tools: 'TOOLS & SUPPLIES', screws: 'FASTENERS & HARDWARE', home: 'MORE PRODUCTS' };
  const slug = /^[a-z0-9][a-z0-9-]{0,99}$/;
  let items = [], storageNotice = '', lastTrigger, toastTimer;
  const keyOf = item => `${item.department}:${item.category}`;
  const imageURL = value => {
    if (typeof value !== 'string' || !value) return '';
    try { const url = new URL(value, document.baseURI); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const cleanItem = item => {
    if (!item || !Object.hasOwn(departmentNames, item.department) || !slug.test(item.category || '')) return null;
    const title = typeof item.title === 'string' ? item.title.trim().slice(0,200) : '';
    if (!title) return null;
    return { department: item.department, category: item.category, title, image: imageURL(item.image) };
  };
  const parseItems = raw => {
    const stored = raw ? JSON.parse(raw) : { items: [] };
    if (!Array.isArray(stored.items)) throw new Error('Invalid wishlist data');
    const unique = new Map();
    for (const candidate of stored.items.slice(0,300)) { const item = cleanItem(candidate); if (item) unique.set(keyOf(item), item); }
    return [...unique.values()];
  };
  try { items = parseItems(localStorage.getItem(storageKey)); }
  catch { storageNotice = 'Your saved wishlist could not be loaded. New selections will stay available in this tab.'; }
  const snapshot = () => items.map(item => ({ ...item }));
  const has = (department, category) => items.some(item => item.department === department && item.category === category);
  const $ = selector => document.querySelector(selector);
  const route = (department, category) => {
    const root = window.Shopify?.routes?.root || '/';
    const preview = document.documentElement.dataset.storePreview === 'true';
    const url = new URL(preview ? `${root}${department || 'all'}.html` : root, window.location.origin);
    if (!preview) url.searchParams.set('view', department || 'all');
    if (category) url.searchParams.set('category', category);
    const theme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (theme) url.searchParams.set('preview_theme_id', theme);
    return url.href;
  };
  const element = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text !== undefined) el.textContent = text; return el; };
  const placeToast = origin => {
    const el = $('[data-wishlist-toast]'); if (!el) return;
    const focusedDialog = (origin || document.activeElement)?.closest?.('dialog');
    const dialog = focusedDialog?.open ? focusedDialog : [...document.querySelectorAll('dialog')].filter(item => item.open).at(-1);
    const host = dialog || document.body;
    if (el.parentElement !== host) host.append(el);
    // A native modal covers ordinary page layers, so feedback must live inside it.
    if (dialog) {
      const rect = dialog.getBoundingClientRect();
      el.style.left = `${Math.max(12,rect.left+16)}px`;
      el.style.bottom = `${Math.max(16,(window.innerHeight || rect.bottom)-rect.bottom+16)}px`;
      el.style.width = `${Math.max(120,rect.right-rect.left-32)}px`;
      el.style.transform = 'none';
    } else { el.style.left = ''; el.style.bottom = ''; el.style.width = ''; el.style.transform = ''; }
  };
  const toast = (message, origin) => {
    const el = $('[data-wishlist-toast]'); if (!el) return;
    clearTimeout(toastTimer); placeToast(origin); el.textContent = message; el.hidden = false;
    toastTimer = setTimeout(() => { el.hidden = true; document.body.append(el); }, 3500);
  };
  const sync = () => {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(items.length); el.hidden = !items.length; });
    document.querySelectorAll('[data-wishlist-open]').forEach(el => {
      el.setAttribute('aria-label', items.length ? `My wishlist, ${items.length} saved product ${items.length === 1 ? 'type' : 'types'}` : 'My wishlist');
      el.setAttribute('aria-expanded', String(Boolean($('[data-wishlist-drawer]')?.open)));
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(el => {
      const saved = has(el.dataset.wishlistDepartment, el.dataset.wishlistCategory);
      const title = el.dataset.wishlistTitle || 'product';
      el.hidden = false; el.setAttribute('aria-pressed', String(saved)); el.classList.toggle('is-saved', saved);
      el.setAttribute('aria-label', saved ? `Remove ${title} from wishlist` : `Save ${title} to wishlist`);
      el.setAttribute('title', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
    const notice = $('[data-wishlist-storage-notice]');
    if (notice) { notice.textContent = storageNotice; notice.hidden = !storageNotice; }
  };
  const render = () => {
    const container = $('[data-wishlist-content]'); if (!container) return;
    const headingCount = $('[data-wishlist-heading-count]'); if (headingCount) headingCount.textContent = items.length ? `(${items.length})` : '';
    container.replaceChildren();
    if (!items.length) {
      const empty = element('div','bh-wishlist__empty');
      empty.append(element('h3','','Your wishlist is empty'),element('p','','Tap the heart on a product to save it here and find it again later.'));
      const shop = element('a','bh-wishlist__shop','Explore products'); shop.href = route(); empty.append(shop); container.append(empty); return;
    }
    const list = element('ul','bh-wishlist__list');
    for (const item of items) {
      const row = element('li','bh-wishlist__item');
      const photo = element('a','bh-wishlist__image-link'); photo.href = route(item.department,item.category); photo.setAttribute('aria-label',`Choose options for ${item.title}`);
      if (item.image) { const img = element('img'); img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 92; img.height = 92; img.addEventListener('error', () => { img.hidden = true; }, { once:true }); photo.append(img); }
      const body = element('div','bh-wishlist__item-body'); body.append(element('span','bh-wishlist__department',departmentNames[item.department]));
      const title = element('a','bh-wishlist__title',item.title); title.href = route(item.department,item.category); body.append(title);
      const actions = element('div','bh-wishlist__actions');
      const choose = element('a','bh-wishlist__choose','Choose options'); choose.href = title.href;
      const remove = element('button','bh-wishlist__remove','Remove'); remove.type = 'button'; remove.dataset.wishlistRemove = keyOf(item); remove.setAttribute('aria-label',`Remove ${item.title} from wishlist`);
      actions.append(choose,remove); body.append(actions); row.append(photo,body); list.append(row);
    }
    container.append(list);
  };
  const persist = () => {
    try { localStorage.setItem(storageKey,JSON.stringify({ version:1, items })); storageNotice = ''; }
    catch { storageNotice = 'This browser could not save your wishlist. Changes are available only in this tab.'; }
    sync(); if ($('[data-wishlist-drawer]')?.open) render();
    window.dispatchEvent(new CustomEvent('buildhome:wishlist-change',{ detail:{ items:snapshot() } }));
  };
  const toggle = (candidate, origin) => {
    const item = cleanItem(candidate); if (!item) return false;
    const index = items.findIndex(saved => keyOf(saved) === keyOf(item));
    if (index >= 0) items.splice(index,1);
    else { if (items.length >= 300) { toast('Your wishlist is full. Remove a product type to add another.',origin); return false; } items.push(item); }
    persist();
    toast(storageNotice ? (index >= 0 ? 'Removed for this visit. Browser storage is unavailable.' : 'Saved for this visit. Browser storage is unavailable.') : (index >= 0 ? 'Removed from your wishlist.' : 'Saved to your wishlist.'),origin);
    return index < 0;
  };
  const restoreFocus = () => {
    document.documentElement.classList.remove('bh-wishlist-open'); sync();
    const target = lastTrigger?.isConnected ? lastTrigger : $('[data-wishlist-open]'); target?.focus();
  };
  const open = trigger => {
    const dialog = $('[data-wishlist-drawer]'); if (!dialog || dialog.open) return;
    lastTrigger = trigger || document.activeElement; render();
    if (typeof dialog.showModal === 'function') dialog.showModal(); else { dialog.setAttribute('open',''); dialog.setAttribute('aria-modal','true'); dialog.setAttribute('role','dialog'); }
    document.documentElement.classList.add('bh-wishlist-open'); sync(); dialog.querySelector('[data-wishlist-close]')?.focus();
  };
  const close = () => {
    const dialog = $('[data-wishlist-drawer]'); if (!dialog?.open) return;
    if (typeof dialog.close === 'function') dialog.close(); else { dialog.removeAttribute('open'); restoreFocus(); }
  };
  const bindDialog = () => {
    const dialog = $('[data-wishlist-drawer]'); if (!dialog || dialog.dataset.wishlistBound) return;
    dialog.dataset.wishlistBound = 'true';
    dialog.addEventListener('close',restoreFocus);
    dialog.addEventListener('cancel',event => { event.preventDefault(); close(); });
  };
  document.addEventListener('click',event => {
    const target = event.target.closest?.('[data-wishlist-toggle],[data-wishlist-open],[data-wishlist-close],[data-wishlist-remove]');
    if (target?.matches('[data-wishlist-toggle]')) {
      event.preventDefault(); event.stopPropagation();
      toggle({ department:target.dataset.wishlistDepartment, category:target.dataset.wishlistCategory, title:target.dataset.wishlistTitle, image:target.dataset.wishlistImage },target); return;
    }
    if (target?.matches('[data-wishlist-open]')) { event.preventDefault(); open(target); return; }
    if (target?.matches('[data-wishlist-close]')) { event.preventDefault(); close(); return; }
    if (target?.matches('[data-wishlist-remove]')) {
      const index = items.findIndex(item => keyOf(item) === target.dataset.wishlistRemove); if (index < 0) return;
      const item = items[index]; toggle(item,target);
      const buttons = [...document.querySelectorAll('[data-wishlist-remove]')];
      (buttons[Math.min(index,buttons.length-1)] || $('.bh-wishlist__shop') || $('[data-wishlist-close]'))?.focus(); return;
    }
    const dialog = $('[data-wishlist-drawer]');
    if (event.target === dialog && dialog.open) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); }
  });
  document.addEventListener('keydown',event => {
    const dialog = $('[data-wishlist-drawer]'); if (!dialog?.open) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],[tabindex="0"]')].filter(el => !el.hidden);
    const first = focusable[0], last = focusable[focusable.length-1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
  });
  window.addEventListener('storage',event => {
    if (event.key !== storageKey && event.key !== null) return;
    try { items = parseItems(event.newValue); storageNotice = ''; sync(); if ($('[data-wishlist-drawer]')?.open) render(); window.dispatchEvent(new CustomEvent('buildhome:wishlist-change',{detail:{items:snapshot()}})); }
    catch { storageNotice = 'Wishlist changes from another tab could not be loaded.'; sync(); }
  });
  document.addEventListener('close',() => { if (!$('[data-wishlist-toast]')?.hidden) placeToast(); },true);
  window.addEventListener('resize',() => { if (!$('[data-wishlist-toast]')?.hidden) placeToast(); });
  window.BuildHomeWishlist = Object.freeze({ has,toggle,open,close,sync,items:snapshot,storageKey });
  bindDialog(); sync();
  new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-wishlist-toggle],[data-wishlist-open],[data-wishlist-drawer]') || node.querySelector?.('[data-wishlist-toggle],[data-wishlist-open],[data-wishlist-drawer]'))))) { bindDialog(); sync(); } }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',() => { bindDialog(); sync(); });
})();
